import { observer } from 'mobx-react-lite';

import { CartItemList } from '../CartItemList';
import {
  ICartItem,
  useCartContext,
} from 'screens/AccessExpressV3/CartProvider';
import EmptyCart from './EmptyCart';
import { useMemo } from 'react';

const ProductBody = observer(
  ({
    locationId,
    category,
  }:
    | { locationId?: number; category?: unknown }
    | { locationId?: unknown; category?: 'Mobility' | 'Access' }) => {
    const cart = useCartContext();

    // const handleEdit = (id: ICartItem['id']) => {
    //   console.log('Edit item:', id);
    // };

    const handleDelete = (id: ICartItem['id']) => {
      if (category === 'Access') {
        cart.removeAccessCartItem(id!);
      } else if (category === 'Mobility') {
        cart.removeMobilityCartItem(id!);
      }
    };

    const handleQuantityChange = (id: ICartItem['id'], newQty: number) => {
      cart.updateItemQuantity(id, newQty);
    };

    const items = useMemo(() => {
      if (cart.items) {
        if (typeof locationId === 'string') {
          return cart.itemsByLocation(locationId);
        } else if (typeof category === 'string')
          return cart.itemsByCategory(category);
      }
      return [];
      // cart.items should be here!
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId, category, cart, cart.items]);

    return (
      <>
        {items.length ? (
          <CartItemList
            items={items}
            // Edit functionality is temporarily disabled and will be re-enabled with G360-3189
            // onEdit={handleEdit}
            onDelete={handleDelete}
            onQuantityChange={handleQuantityChange}
          />
        ) : (
          <EmptyCart />
        )}
      </>
    );
  },
);

export default ProductBody;
